<template>
	<div class="vue-audio" v-if="src">
		<audio-aplayer mutex autoplay theme="#41466E" :music="misicData"></audio-aplayer>
	</div>
</template>

<script>
	import vueAplayer from 'vue-aplayer'
	export default {
		name: 'vue-audio',
		props: {
			src: {
				type: String,
				default: 'https://panvr.xitohere.com/testMarzipano/bgAudio/happy/Pickled Pink.mp3'
			},
			name: {
				type: String,
				default: ''
			},
			photo: {
				type: String,
				default: require('../../../../assets/image/music.png')
			}
		},
		data() {
			return {
				misicData: {
					// url: this.src,
					src: this.src,
					pic: this.photo,
					title: this.name
				}
			}
		},
		components: {
			'audio-aplayer': vueAplayer
		}
	}
</script>

<style scoped lang="less">
	.vue-audio{
		width: 100%;
	}
</style>
